<template>
  <NotificationTemplate
    :notification="notification"
    :projectName="notification.projectName"
    :showSubTitle="false"
    class="notification__milestone-back-to-track"
  >
    <template #pic>
      <div class="label-pic is-green">
        <icon
          data="@icon/milestoneIcon.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <div class="notification-title-flex">
        <BaseSubHeading
          size="large"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="500"
        >
          Milestone Back on Track!
        </BaseSubHeading>
        <BaseSubHeading
          size="small"
          color="monochrome-05"
          darkColor="monochrome-04"
          weight="500"
        >
          {{ notification.projectName }}
        </BaseSubHeading>
      </div>
    </template>
    <template #content>
      <div className="notification__update-item__content">
        <a
          :href="notification.url"
          class="link is-medium-500"
          target="_blank"
        >
          {{ notification.milestoneName }}
        </a>
        <BaseSubHeading
          size="medium"
          color="monochrome-07"
          weight="500"
          className="body-text-medium-500 milestone-date"
        >
          {{ notification.milestoneDate }}
        </BaseSubHeading>
      </div>
      <BaseSubHeading
        size="medium"
        color="monochrome-07"
        weight="500"
        className="body-text-medium-500 notification__update-item__content"
      >
        {{ notification.daysLeft }} Days Left, {{ notification.percentComplete }}% Done
      </BaseSubHeading>
      <BaseSubHeading
        v-if="notification.currentGoalContent"
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        {{ notification.currentGoalContent }}
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationMilestone } from "@/models/Notification"

@Options({
  name: "MILESTONE_BACK_TO_TRACK",
  components: {
    NotificationTemplate
  }
})
export default class MILESTONE_BACK_TO_TRACK extends Vue {
  @Prop() readonly notification: NotificationMilestone
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/utils/mixins/_flex";

.notification-title-flex {
  @include flex($justify: space-between, $align: center);

  gap: 4px;
}
</style>
